import React from "react";

interface PlainLayoutProps {
    page: any;
}

export const PlainLayout = ({ page }: PlainLayoutProps) => {
    return <>{page}</>;
};
